import { FETCH_GENRES, baseUrl } from "./actionType";

export const fetchSuccess = (type, payload) => {
  return {
    type,
    payload,
  };
};

export const fetchGenres = () => {
  return function (dispatch) {
    return fetch(`${baseUrl}/public/genres`)
      .then((res) => {
        if (!res.ok) {
          return res.json().then((msg) => {
            throw msg;
          });
        }
        return res.json();
      })
      .then((data) => {
        dispatch(fetchSuccess(FETCH_GENRES, data));
      });
  };
};
